import React from "react";
import styled from "styled-components";
import Navbar from '../components/Navbar'

const TermsOfService = () => {

    return(
        <Wrapper>
        <Navbar/>
        <Container>
            
            <div className="page-content">
                <div className="content-header">
                    <h1>Terms and Conditions</h1>
                    <p><i>Last updated: <span>25th February, 2025 </span> </i></p> 
                    <p>  Please read these terms and conditions carefully before using our service.
    </p>
                </div>

                <div className="content-main">
                    <h3>Summary</h3>
                    <p>These are the Terms and Conditions governing the use of this service and the agreement that operates between the user and AMRS Ghana. These Terms and Conditions set out the rights and obligations of all users regarding the use of the service.
                        Your access to use our service is conditioned on your acceptance of and compliance with these Terms and Conditions. These Terms and Conditions apply to all visitors and registered members who make use of our service.</p>

                    <p>By accessing or using our service, the user agrees to be bound by these Terms and Conditions. If there is any disagreement with any part of these Terms and Conditions then access to our service will be limited.
                    You represent that you are over the age of 16. AMRS Ghana does not permit those under 16 to use the Service.
                     Our Privacy Policy describes our policies and procedures on the collection, use and disclosure of any users personal information when using any of our application features and informs privacy rights and how the law protects you. Please read our Privacy Policy carefully before using our service.
                    </p>

                    <h3>Termination</h3>
                    <p>We may terminate or suspend your access immediately, with prior notice or liability, for any reason whatsoever, including without limitation if a user breaches these Terms and Conditions. Upon termination, your right to use the service will cease immediately.</p>

                    <h3>Limitation of Liability</h3>
                    <p>Notwithstanding any damages that you might incur, the entire liability of AMRS Ghana and any of its suppliers under any provision of this Terms and Your exclusive remedy for all of the foregoing shall be limited to the amount actually paid by You through the Service if You haven't purchased anything through the Service.</p>
                    <p>To the maximum extent permitted by applicable law, in no event shall AMRS Ghana or its suppliers be liable for any special, incidental, indirect, or consequential damages whatsoever (including, but not limited to, damages for loss of profits, loss of data or other information, for business interruption, for personal injury, loss of privacy arising out of or in any way related to the use of or inability to use the Service, third-party software and/or third-party hardware used with the Service, or otherwise in connection with any provision of this Terms), even if AMRS Ghana or any supplier has been advised of the possibility of such damages and even if the remedy fails of its essential purpose.</p>

                    <h3>Payment Processing</h3>
                    <p>Payments are securely processed through our third-party payment partners. By submitting your payment information, you authorize us to charge the specified amount for the conference or event registration.</p>

                    <h3>Disputes</h3>
                    <p>If you encounter issues with payments, please contact us at <a href="mailto:amrsghana@gmail.com">amrsghana@gmail.com</a> for resolution.</p>

                    <h3>Severability</h3>
                    <p>If any provision of these Terms is held to be unenforceable or invalid, such provision will be changed and interpreted to accomplish the objectives of such provision to the greatest extent possible under applicable law and the remaining provisions will continue in full force and effect.</p>

                    <h3>Waiver</h3>
                    <p>Except as provided herein, the failure to exercise a right or to require performance of an obligation under these Terms shall not affect a party's ability to exercise such right or require such performance at any time thereafter nor shall the waiver of a breach constitute a waiver of any subsequent breach.</p>

                    <h3>Changes to These Terms and Conditions</h3>
                    <p>We reserve the right, at Our sole discretion, to modify or replace these Terms at any time. If a revision is material, We will make reasonable efforts to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at Our sole discretion.</p>
                    <p>By continuing to access or use Our Service after those revisions become effective, You agree to be bound by the revised terms. If You do not agree to the new terms, in whole or in part, please stop using the website and the Service.</p>

                    <h3>Contact Us</h3>
                    <p>If you have any questions about these Terms and Conditions, You can contact us:</p>
                    <p>By email: <a href="mailto:amrsghana@gmail.com">amrsghana@gmail.com</a> <br/>
                       By phone number: +233 45678910 <br/>
                       By post: P.O Box LG 77, University of Ghana, Accra-Ghana
</p>

                </div>
            </div>
        </Container>
        </Wrapper>
    );

};
const Wrapper = styled.div`
`
const Container = styled.div`
    margin: 0 auto;
    font-family: 'Inter', sans-serif;
    h3{ font-size: 1em; }
    p { line-height: 1.7; }
    

        .page-content{
            width: 50rem;
            margin: 1.5em 3em 0em 3em;

            h1{color: #CA9D3B;}
        }

    @media only screen and (min-width: 800px){
        h3 {
        font-size: 1.9em;
        margin-bottom: 20px;
        }


        .page-content{
            width: 65rem;
            margin: 1.5em 0em 0em 3em;


            .content-header{
                

                h1{ 
                    font-size: 3em;
                    }
            }
            
            .content-main{
            
            }
        }
    }
`

export default TermsOfService;